<template>
  <div class="prizes-page">
    <div class="container">
        <h1 class="text-uppercase text-center mt-5 mb-4" v-html="$t('Prizes.PrizesTitle')"></h1>
        <p class="text-center h2" v-html="$t('Prizes.PrizesSubTitle')"></p>
        <p class="text-center mb-5" v-html="$t('Prizes.PrizesDescription')"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Prizes',
  components: {
    // Import components here if needed
  },
  props: {
    // Define props here
  },
  data() {
    return {
      // Define reactive data here
    };
  },
  computed: {
    // Define computed properties here
  },
  methods: {
    // Define methods here
  },
  mounted() {
    // Lifecycle hook
  },
};
</script>

<style scoped>

</style>